const HeroVariant3 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-8"
      style={{ backgroundColor: theme.backgroundColor, fontFamily: font.mainText }}
    >
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-center">
        <div className="flex justify-center">
          <div
            className="w-full h-80 rounded-xl border-2 border-dashed flex items-center justify-center"
            style={{ borderColor: theme.primaryColor }}
          >
            <span style={{ color: theme.primaryColor }}>
              {renderEditable
                ? renderEditable("imagePlaceholder", getText("imagePlaceholder", "Illustration Here"))
                : getText("imagePlaceholder", "Illustration Here")}
            </span>
          </div>
        </div>
        <div>
          <h1 className="text-4xl font-bold mb-4" style={{ color: theme.primaryColor }}>
            {renderEditable
              ? renderEditable("heading", getText("heading", "Drive Innovation with Our Platform"))
              : getText("heading", "Drive Innovation with Our Platform")}
          </h1>
          <p className="text-lg mb-6" style={{ color: theme.textColor }}>
            {renderEditable
              ? renderEditable("subheading", getText("subheading", "Create, scale, and optimize digital experiences that delight users and grow businesses."))
              : getText("subheading", "Create, scale, and optimize digital experiences that delight users and grow businesses.")}
          </p>
          <div className="flex gap-4">
            <button
              className="px-6 py-3 rounded-lg font-medium transition-all"
                style={{ backgroundColor: theme.primaryColor, color: theme.backgroundColor }}
            >
              {renderEditable
                ? renderEditable("primaryButton", getText("primaryButton", "Learn More"))
                : getText("primaryButton", "Learn More")}
            </button>
            <button
              className="px-6 py-3 rounded-lg font-medium border-2 transition-all"
              style={{ borderColor: theme.primaryColor, color: theme.primaryColor }}
            >
              {renderEditable
                ? renderEditable("secondaryButton", getText("secondaryButton", "Contact Sales"))
                : getText("secondaryButton", "Contact Sales")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroVariant3;
